import api from 'api/instance';
import { UserInfo } from 'types/user';

const URL = `${process.env.REACT_APP_API_URL}/user`;

export const getUserInfo = async (): Promise<UserInfo> => {
  const { data } = await api.get(URL);
  return data;
};
